/**
 * Module-level dedup so all ShareSlideUp instances on the same petition share a single
 * "fired" state. Survives across mounts within the same SPA session; resets on full reload.
 */
export const firedExperiments = new Set<string>();
